// src/hooks/auth/useForgotPassword.ts
import { useState } from "react";
import { request } from "@/api/client";
import { PATHS } from "@/api/constants";

type ApiResponse = {
  ok?: boolean;
  message?: string;
};

export function useForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (email: string) => {
    const trimmed = email.trim();
    if (!trimmed) return;

    try {
      setLoading(true);
      setError(null);

      const res = await request<ApiResponse>({
        method: "POST",
        url: PATHS.auth.requestPasswordReset, // using constant
        data: { email: trimmed },
      });

      if (res && res.ok === false) {
        throw new Error(res.message || "Unable to send reset link.");
      }

      setSent(true);
      return res;
    } catch (err: any) {
      setError(err?.message || "Unable to send reset link.");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setSent(false);
    setError(null);
  };

  return {
    submit,
    loading,
    sent,
    error,
    reset,
  };
}
